export const ADMIN = 1;
export const BACKOFFICE = 2;
export const CONCIERGE = 3;
export const CUSTOMER = 4;
export const INHABITANT = 5;
export const GUEST = 6;
export const EMPLOYEE = 7;
export const BEWIRTSCHAFTER = 8;

export default Object.freeze({
  ADMIN,
  BACKOFFICE,
  CONCIERGE,
  CUSTOMER,
  INHABITANT,
  GUEST,
  EMPLOYEE,
  BEWIRTSCHAFTER
});
